import { useParameter } from '../../../shared';
import { useCommoditiesGroupName } from './useCommoditiesGroupName';

export function useChartTitle(worldValue: number | undefined | null) {
  const [business] = [1]; //useParameter<number>("@business-units");
  const commoditiesGroupName = useCommoditiesGroupName();
  const worldValueDisplay = worldValue ? (worldValue).toFixed(1) : 'N/A';
  const businessUnitDisplay = business !== 2 ? 'worldwide' : 'APE';
  return `Major ${commoditiesGroupName} = ~${worldValueDisplay}% of ${businessUnitDisplay} crop value`;
}